import ToolboxTableHeaderElement from './ToolboxTableHeader.jsx';

export default ToolboxTableHeaderElement;
